<template>
    <section class="mission-section card border-0 shadow-sm my-3">
        <div class="card-body p-3 p-md-4">
            <div class="section-header mb-3 mb-md-4">
                <div class="section-title-wrap">
                    <div class="section-icon section-icon-live">
                        <i class="fa-solid fa-satellite-dish"></i>
                    </div>
                    <div>
                        <p class="section-kicker mb-1">Suivi en direct</p>
                        <h5 class="section-title mb-0">
                            {{ missions.length > 0 ? 'Missions en cours' : 'Aucune mission en cours' }}
                        </h5>
                    </div>
                </div>

                <div v-if="!$isViewer" class="section-actions">
                    <ButtonDisplay @click="$router.push('/mission/new')" :type="'add'" :text="'Nouvelle mission'" />
                </div>
            </div>
            <div v-if="missions.length" class="row gx-4 gy-3 justify-content-start">
                <div v-for="mission in missions" :key="mission.id" class="col-auto">
                    <MissionDisplaySmall :mission="mission" />
                </div>
            </div>
            <div v-else class="empty-state">
                <div class="empty-state-icon">
                    <i class="fa-regular fa-circle-check"></i>
                </div>
                <div>
                    <h6 class="empty-state-title mb-1">Aucune mission active</h6>
                    <p class="empty-state-text mb-0">
                        Les nouvelles missions démarrées apparaîtront ici automatiquement.
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import ButtonDisplay from '@/components/display/ButtonDisplay.vue'
import MissionDisplaySmall from './MissionDisplaySmall.vue'
import MissionRepository from '@/repositories/mission.repo'

export default {
    components: {
        MissionDisplaySmall,
        ButtonDisplay
    },
    data() {
        return {
            missions: [],
            timer: ''
        };
    },
    created() {
        this.refreshData();
        this.timer = setInterval(this.refreshData, 10000);
    },
    beforeUnmount() {
        clearInterval(this.timer);
    },
    methods: {
        // Get the balise data
        refreshData() {
            MissionRepository.getOngoing()
                .then(missions => { this.missions = missions; })
                .catch(e => {
                    console.log(e);
                });
        },
    }
}
</script>


<style scoped>
.mission-section {
    border-radius: 22px;
    background: #ffffff;
    border: 1px solid #cfd8e3;
    box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06) !important;
}

.card-body {
    padding-top: 1.25rem;
}

.section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    flex-wrap: wrap;
    padding-bottom: 1.1rem;
    margin-bottom: 1rem;
    border-bottom: 1px solid #dde5ee;
}

.section-title-wrap {
    display: flex;
    align-items: center;
    gap: 0.95rem;
}

.section-icon {
    width: 48px;
    height: 48px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    flex-shrink: 0;
}

.section-icon-live {
    color: #198754;
    background: rgba(25, 135, 84, 0.16);
}

.section-kicker {
    font-size: 0.78rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: #64748b;
}

.section-title {
    font-size: 1.2rem;
    font-weight: 700;
    color: #0f172a;
}

.section-actions {
    margin-left: auto;
}

.empty-state {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1.25rem;
    border: 1px dashed #cfd8e3;
    border-radius: 18px;
    background: #fcfdff;
}

.empty-state-icon {
    width: 52px;
    height: 52px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f8fafc;
    border: 1px solid #d6dee8;
    color: #64748b;
    font-size: 1.25rem;
    flex-shrink: 0;
}

.empty-state-title {
    font-weight: 700;
    color: #0f172a;
}

.empty-state-text {
    color: #64748b;
    line-height: 1.5;
}

@media (max-width: 767.98px) {
    .mission-section {
        border-radius: 18px;
    }

    .section-icon {
        width: 42px;
        height: 42px;
        border-radius: 12px;
    }
}
</style>